<template>
  <div class="suggested-products critical-component-clear">
    <recommendations-carousel
      :bloomreach-recommendation-id="bloomreachRecommendationId"
      :collection="collection"
      :config="config"
      :heading="heading"
      :initial-recommendations-state="initialRecommendationsState"
      :limit="limit"
      :liquid="liquid"
      :product-data-source="productDataSource"
    />
  </div>
</template>

<script>

/**
 * Vue: Suggested products (suggested-products)
 * -----------------------------------------------------------------------------
 * Renders a carousel of product cards with data from Shopify Collections or
 * Bloomreach recommendations.
 *
 * @param {String} bloomreachRecommendationId - Bloomreach recommendation ID.
 * @param {Boolean|Object} collection - Shopify formatted collection object.
 * @param {Object} heading - Settings for heading-copy.
 * @param {String} initialRecommendationsState - Initial vue loading state.
 * @param {Number} limit - Max number of products to display.
 * @param {String} liquid.sectionId - Section's Liquid ID.
 * @param {String} productDataSource - Pull products from Shopify or Bloomreach.
 *
 */
import { values as breakpoints } from '~/config/breakpoints'

import RecommendationsCarousel from '~async/recommendations-carousel/recommendations-carousel'

export default {
  name: 'SuggestedProducts',

  components: {
    RecommendationsCarousel,
  },

  props: {
    bloomreachRecommendationId: {
      type: String,
      default: '',
    },
    collection: {
      type: [Boolean, Object],
      default: false,
    },
    heading: {
      type: Object,
      default: () => ({
        classes: {},
        heading: '',
      }),
    },
    initialRecommendationsState: {
      type: String,
      default: 'loading',
    },
    limit: {
      type: Number,
      default: 8,
    },
    liquid: {
      type: Object,
      default: () => ({
        productDataSource: 'shopify',
        sectionId: '',
      }),
    },
    productDataSource: {
      type: String,
      default: 'shopify',
      validator: (value) => ['bloomreach', 'shopify'].includes(value),
    },
  },

  data() {
    return {
      config: {
        arrows: true,
        autoWidth: true,
        breakpoints: {
          [breakpoints.l]: {
            arrows: false,
            fixedWidth: '83%',
            gap: 'var(--layout-mobile-gutter)',
            padding: {
              left: 'var(--layout-mobile-margin)',
              right: 'var(--layout-mobile-margin)',
            },
            pagination: true,
            perMove: 1,
            perPage: 1,
          },
        },
        direction: 'ltr',
        drag: true,
        gap: 'var(--layout-desktop-gutter)',
        padding: {
          left: 'var(--layout-desktop-margin)',
          right: 'var(--layout-desktop-margin)',
        },
        pagination: false,
        pauseOnHover: false,
        perMove: 1,
        perPage: 4,
        speed: this.$timing('normal'),
        start: 0,
        type: 'slide',
      },
    }
  },
}
</script>

<style lang="scss">
@import './suggested-products';
</style>
